
define('template!companiesDetailBodySubaccountsView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="subaccounts-toolbar">\n  <label class="subaccounts-select-all">\n    <input type="checkbox" class="js-select-all"/>\n    ' +
((__t = ( _.i18n('common.selectAll', null, 'Select all') )) == null ? '' : __t) +
'\n  </label>\n  <span class="subaccounts-selected js-selected-count"></span>\n  <button type="button" class="btn btn-sm subaccounts-prospection js-add-prospection" disabled="disabled">\n    <i class="fa fa-bullseye"></i> ' +
((__t = ( _.i18n('prospection.addSelected', null, 'Add selected to prospection') )) == null ? '' : __t) +
'\n  </button>\n</div>\n<table class="table table-hover subaccounts-table">\n  <thead>\n    <tr>\n      <th class="sel"></th>\n      <th>' +
((__t = ( _.i18n('common.code') )) == null ? '' : __t) +
'</th>\n      <th>' +
((__t = ( _.i18n('common.name') )) == null ? '' : __t) +
'</th>\n      <th>' +
((__t = ( _.i18n('common.firstName') )) == null ? '' : __t) +
'</th>\n      <th>' +
((__t = ( _.i18n('common.lastName') )) == null ? '' : __t) +
'</th>\n      <th>' +
((__t = ( _.i18n('common.email') )) == null ? '' : __t) +
'</th>\n      <th>' +
((__t = ( _.i18n('common.city') )) == null ? '' : __t) +
'</th>\n    </tr>\n  </thead>\n  <tbody class="subaccount-rows"></tbody>\n</table>\n';

}
return __p
};});

